import useCoreModelsFindAll from '../../../hooks/useCoreModelsFindAll'

export default () => useCoreModelsFindAll('schedulePosition', { where: {} })
